import { render, staticRenderFns } from "./InvoicesToAddToJournal.vue?vue&type=template&id=47a6426a&scoped=true&"
import script from "./InvoicesToAddToJournal.vue?vue&type=script&lang=js&"
export * from "./InvoicesToAddToJournal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a6426a",
  null
  
)

export default component.exports